<div *ngIf="show" class="export-modal-overlay" (click)="cancel()">
  <div class="export-modal" (click)="$event.stopPropagation()">
    <h3 class="export-modal__title">Exportar Relatório</h3>
    <p class="export-modal__subtitle">Filtre os dados antes de exportar. Deixe em branco para exportar tudo.</p>

    <div class="export-modal__grid">
      <div class="export-modal__field">
        <label class="export-modal__label">Empresa</label>
        <ng-select
          [items]="companyOptions"
          bindLabel="name"
          bindValue="name"
          [clearable]="false"
          [searchable]="true"
          [formControl]="exportCompanyControl"
        ></ng-select>
      </div>

      <div class="export-modal__field">
        <label class="export-modal__label">Situação</label>
        <ng-select
          [items]="statusFuncionarioOptions"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          [formControl]="exportCollaboratorStatusControl"
        ></ng-select>
      </div>

      <div class="export-modal__field">
        <label class="export-modal__label">Cartão Ativo</label>
        <ng-select
          [items]="simNaoOptions"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          [formControl]="exportCardStatusControl"
        ></ng-select>
      </div>
    </div>

    <div class="export-modal__actions">
      <button class="btn-cancel" (click)="cancel()" [disabled]="isExporting">Cancelar</button>
      <button class="btn btn--primary bg-blumine" (click)="confirm()" [disabled]="isExporting">
        {{ isExporting ? 'Exportando...' : 'Exportar' }}
      </button>
    </div>
  </div>
</div>
